<template>
  <section class="about-us-section" id="anchor-sect">
    <div class="container">
      <div class="row no-gutters about-us-wrapper">
        <div class="col-12 col-xl-7 about-us-text wow fadeInLeft" data-wow-duration="2s" data-wow-delay=".5s">
          <span v-bind="$parent.dKey('b2subtitle')" class="section-title">{{subtitle}}</span>
          <h2 v-bind="$parent.dKey('b2title')">{{title}}</h2>
          <div v-bind="$parent.dKey('b2text')" v-html="content"></div>
        </div>
        <div class="col-12 col-xl-5 about-us-img p-0 wow fadeInRight" data-wow-duration="2s" data-wow-delay=".5s">
          <div class="out-container-img">
            <img src="/static-assets/img/about-us-img.jpg" alt="">
          </div>
          <span v-bind="$parent.dKey('b2imageTitle')" class="big-section-title resp-number fs-smaller">{{bgTitle}}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'HomeAbout',

  props: ['title', 'content', 'image', 'subtitle', 'bgTitle'],

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  }
}

</script>
